import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  UserRegistrationRequest,
  UserRegistrationResponse,
  UpdateUserSceRequest,
  UserByUuidResponse,
  UpdateAddressRequest,
  UpdateUserRequest,
  UpdateDocumentRequest,
  UpdateDocumentResponse,
} from '../models/user.model';
import { SelectContractRequest } from '../models/login.model';

import { ApiService } from './api.service';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly API_URL = '/user';
  private apiService = inject(ApiService);


  registerUser(
    payload: UserRegistrationRequest
  ): Observable<UserRegistrationResponse> {
    return this.apiService.post<UserRegistrationResponse>(
      `${this.API_URL}/registration`,
      payload
    );
  }

  // metodo usava um header customizado = X-Host-Domain: CLARO
  getCompanyByDocument(document: string): Observable<any> {
    return this.apiService.get(`${this.API_URL}/company/${document}`);
  }

  validateCompanyByUuid(uuid: string): Observable<any> {
    return this.apiService.get(`${this.API_URL}/company/validate/${uuid}`);
  }

  updateUserSce(uuid: string, payload: UpdateUserSceRequest): Observable<any> {
    return this.apiService.put(`${this.API_URL}/update/sce/${uuid}`, payload);
  }

  getUserByUuid(uuid: string): Observable<UserByUuidResponse> {
    return this.apiService.get<UserByUuidResponse>(
      `${this.API_URL}/${uuid}`
    );
  }

  updateUserAddress(userUuid: string, addressUuid: string, payload: UpdateAddressRequest): Observable<any> {
    return this.apiService.put(`${this.API_URL}/${userUuid}/update/address/${addressUuid}`, payload);
  }

  updateUser(uuid: string, payload: UpdateUserRequest): Observable<any> {
    return this.apiService.put(`${this.API_URL}/v2/${uuid}`, payload);
  }

  updatePassword(uuid: string, oldPassword: string, newPassword: string, confirmNewPassword: string): Observable<any> {
    const payload = {
      oldPassword,
      newPassword,
      confirmNewPassword
    };
    return this.apiService.put(`${this.API_URL}/${uuid}/update/password/v2`, payload);
  }

  updateUserDocument(userUuid: string, document: string): Observable<UpdateDocumentResponse> {
    const payload: UpdateDocumentRequest = { document };
    return this.apiService.put<UpdateDocumentResponse>(
      `${this.API_URL}/document/${userUuid}`,
      payload
    );
  }

  selectContract(request: SelectContractRequest): Observable<any> {
    return this.apiService.post(`${this.API_URL}/select-contract`, request);
  }
}
